import React from 'react';
import SubHeader from '../SubHeader.jsx';

// Loading / empty / error line, same pattern as the Initiatives tab empty state
const EmployeeTabMessage = ({ children }) => (
  <SubHeader bgWhite>
    <p className="text-muted m-0">{children}</p>
  </SubHeader>
);

export default EmployeeTabMessage;
